(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["explore-page"] && !Shopify.designMode) return;
  try {
    

let wrapper = document.querySelector('.explorePage');
let images = document.querySelectorAll('.explorePage img');
let exploreLocked = false;

window.addEventListener('DOMContentLoaded', function() {
  let wrapper = document.querySelector('.explorePage');
  wrapper.style.height = window.innerHeight + 'px';
});

window.addEventListener('resize', function() {
  initImagesPosition();
  images.forEach(image => {
    image.classList.add('resized');
  });
});

wrapper.addEventListener('click', function() {
    if (exploreLocked) {
      return;
    }

    let index = parseInt(wrapper.getAttribute('data-count'));
    if (images[index]) {
        images[index].classList.add('show');
        index++;
        wrapper.setAttribute('data-count', index);
        wrapper.classList.add('started');
    }

    if (!images[index]) {
        exploreLocked = true;
        wrapper.classList.remove('started');
        wrapper.setAttribute('data-count', 0);
        images.forEach(image => {
          image.classList.remove('show');
        });

        setTimeout(function() {
          images.forEach(image => {
            randomizeImage(image);
          });
          exploreLocked = false;
        }, 400);
    }
});

function randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min)
}

function randomizeImage(image)
{
  if (image.width < window.innerWidth * 0.15) {
    image.style.width = window.innerWidth * 0.15 + 'px';
  }

  let randomX = randomIntFromInterval(50, window.innerWidth - image.clientWidth - 50);
  let randomY = randomIntFromInterval(50, window.innerHeight - image.clientHeight - 50);

  let left = parseInt(100 * randomX / window.innerWidth);
  let top = parseInt(100 * randomY/ window.innerHeight);
  image.style.left = left + '%';
  image.style.top = top + '%';
}

function initImagesPositionOnLoad()
{
    images.forEach(image => {
        image.onload = function() {
          randomizeImage(image);
        };
    });
}

function initImagesPosition()
{
    images.forEach(image => {
      randomizeImage(image);
    });
}

initImagesPosition();
initImagesPositionOnLoad();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
    class LocalizationForm extends HTMLElement {
        constructor() {
            super();
            this.elements = {
                input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
                button: this.querySelector('button'),
                panel: this.querySelector('.disclosure__list-wrapper'),
            };
            this.elements.button.addEventListener('click', this.openSelector.bind(this));
            this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
            this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

            this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
        }

        hidePanel() {
            this.elements.button.setAttribute('aria-expanded', 'false');
            this.elements.panel.setAttribute('hidden', true);
        }

        onContainerKeyUp(event) {
            if (event.code.toUpperCase() !== 'ESCAPE') return;

            this.hidePanel();
            this.elements.button.focus();
        }

        onItemClick(event) {
            event.preventDefault();
            const form = this.querySelector('form');
            this.elements.input.value = event.currentTarget.dataset.value;
            if (form) form.submit();
        }

        openSelector() {
            this.elements.button.focus();
            this.elements.panel.toggleAttribute('hidden');
            this.elements.button.setAttribute(
                'aria-expanded',
                (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
            );
        }

        closeSelector(event) {
            const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
            if (event.relatedTarget === null || shouldClose) {
                this.hidePanel();
            }
        }
    }

    customElements.define('localization-form', LocalizationForm);

    let titles = document.querySelectorAll('.footerColumn .title');
    titles.forEach((title) => {
        title.addEventListener('click', function () {
            title.closest('.footerColumn').classList.toggle('active');
        });
    });

    let newsTitle = document.querySelector('.newsletterWrapper .footer-block__heading');
    let newsForm = document.querySelector('footer .newsletterWrapper .newsletter-form');
    newsTitle.addEventListener('click', function () {
        newsForm.classList.toggle('active');
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.flickity-carousel')) {
              // Esperar al siguiente "paint" para asegurarse que los nodos están en el DOM
              requestAnimationFrame(() => {
                new Flickity(this.querySelector('.flickity-carousel'), {
                  wrapAround: false,
                  pageDots: false,
                  contain: true,
                  cellAlign: 'left'
                });
              });
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px'
      }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["two-columns-mobile"] && !Shopify.designMode) return;
  try {
    
    document.body.classList.add('overflow-hidden');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["two-columns-scroll"] && !Shopify.designMode) return;
  try {
    
    document.body.classList.add('overflow-hidden');

    /*
  let wrapper = document.querySelector('.twoColumnsScroll');
  let left = document.querySelector('.twoColumnsScroll .left');
  let innerLeft = document.querySelector('.twoColumnsScroll .left .inner');
  let right = document.querySelector('.twoColumnsScroll .right');
  let innerRight = document.querySelector('.twoColumnsScroll .right .inner');


  let oldValue = 0;
  let newValue = 0;
  let direction = 'down';
  let lock = false;

  window.addEventListener('scroll', (e) => {
    if (isTouchDevice()) {
      return;
    }
    newValue = window.pageYOffset;
    if (oldValue < newValue) {
      direction = 'down';
    } else if (oldValue > newValue) {
      direction = 'up';
    }
    oldValue = newValue;

    if (direction == 'down') {
      
      if (scrollY >= wrapper.offsetTop && scrollY < wrapper.offsetTop + wrapper.offsetHeight) {
        if (lock) {
          return;
        }
        lock = true;
        document.body.classList.add('overflow-hidden');
        document.body.classList.remove('overflow-auto');
        wrapper.classList.add('free');
        window.scrollTo(0, wrapper.offsetTop);
      } else {
        wrapper.classList.remove('free');
        document.body.classList.add('overflow-auto');
        document.body.classList.remove('overflow-hidden');
        lock = false;
      }
    } else {
      if (scrollY <= wrapper.offsetTop && scrollY > wrapper.offsetTop - wrapper.offsetHeight) {
        if (lock) {
          return;
        }
        lock = true;
        document.body.classList.add('overflow-hidden');
        document.body.classList.remove('overflow-auto');
        wrapper.classList.add('free');
        window.scrollTo(0, wrapper.offsetTop);
      } else {
        wrapper.classList.remove('free');
        document.body.classList.add('overflow-auto');
        document.body.classList.remove('overflow-hidden');
        lock = false;
      }
    }
  });

  left.addEventListener('scroll', (e) => {
    if (innerLeft.offsetHeight - window.innerHeight <= e.target.scrollTop) {
      wrapper.classList.remove('free');
      document.body.style.overflow = 'auto';
    } else if (e.target.scrollTop <= 0) {
      wrapper.classList.remove('free');
      document.body.style.overflow = 'auto';
    }
  });

  right.addEventListener('scroll', (e) => {
    if (innerRight.offsetHeight - window.innerHeight <= e.target.scrollTop) {
      wrapper.classList.remove('free');
      document.body.style.overflow = 'auto';
    } else if (e.target.scrollTop <= 0) {
      wrapper.classList.remove('free');
      document.body.style.overflow = 'auto';
    }
  });

  */

  } catch(e) { console.error(e); }
})();
})();
